"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const Navigation_1 = __importDefault(require("../ShoppingCart/Navigation"));
const react_router_dom_1 = require("react-router-dom");
const withStore_1 = __importDefault(require("../../../common/decorators/withStore"));
const Wrapper = styled_components_1.default.div `
  height: ${({ withReducedHeight }) => (withReducedHeight ? 'calc(100vh - 60px)' : '100%')};
  color: #666;
`;
const Iframe = styled_components_1.default.iframe `
  width: 100%;
  height: 100%;
  border: 0;
  display: block;
  background: #fff;
`;
const ExternalCheckinLinkout = ({ iframeSrc, baseUrl, headline, withReducedHeight }) => {
    const history = (0, react_router_dom_1.useHistory)();
    const headerTitle = headline || '';
    const handleClose = () => {
        history.push(baseUrl);
    };
    return (react_1.default.createElement(Wrapper, { withReducedHeight: withReducedHeight, "data-testid": "external-checkin-linkout-wrapper" },
        react_1.default.createElement(Navigation_1.default, { icon: "close", onClick: handleClose, headline: headerTitle }),
        react_1.default.createElement(Iframe, { src: iframeSrc, title: "Pre-checkin form", sandbox: "allow-forms allow-scripts allow-same-origin", referrerPolicy: "strict-origin-when-cross-origin", loading: "eager" })));
};
const mapStoreToProps = (store) => ({
    baseUrl: store.getValue('baseUrl'),
});
exports.default = (0, withStore_1.default)(mapStoreToProps)(ExternalCheckinLinkout);
